import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import LoadingSweep from '../../common/LoadingSweep';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';
import useSweepNavigate from '../../../navigation-utils/useSweepNavigate';
import { selectUserAccountId } from '../../../reducers/userInfoReducer';
import { readableUUID } from '../../../navigation-utils/readableUUID';

/**
 * Redirects from routes with crmOrgId but without accountId
 * to routes with both crmOrgId and accountId
 *
 * Example: /alerts/abc123 → /alerts/abc123/def456
 */
export const RedirectToAddAccountId = () => {
  const { navigate } = useSweepNavigate();
  const userAccountId = useSelector(selectUserAccountId);
  const { pathname } = useLocation();

  const readableAccountId = userAccountId ? readableUUID(userAccountId) : undefined;
  const targetPath = readableAccountId ? `${pathname}/${readableAccountId}` : undefined;

  useRunOnceWhenTruthy(() => {
    if (targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, !!targetPath);

  return <LoadingSweep />;
};
